// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var OperationType;
(function (OperationType) {
    OperationType[OperationType["Buy"] = 0] = "Buy"; /* Const.VALUE_BUY replacement */
    OperationType[OperationType["Sell"] = 1] = "Sell"; /* Const.VALUE_SELL replacement */
})(OperationType || (OperationType = {}));
